import { TooltipPositions } from '../../tooltip/Tooltip';
import { withTooltip } from '../../tooltip/withTooltip';

import { IconButton, Icons } from './IconButton';

const IconButtonWithTooltip = withTooltip(IconButton);

IconButtonWithTooltip.displayName = 'IconButtonWithTooltip';

export { IconButtonWithTooltip, Icons, TooltipPositions };
